import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AppConfigService } from './app-config.service';
import { ErrorHandlerService } from './error-handler.service';
import { ArchiveJobIdTitle } from '../models/archive-job.model';
import { BulkDocAddPayload } from '../models/review/bulk-doc-add-payload.model';

@Injectable({
	providedIn: 'root'
})
export class ArchiveJobService {

	constructor(private http: HttpClient, private errorHandler: ErrorHandlerService, private appConfigService: AppConfigService) { }

	public getArchiveJobsStatusPreRun(): Observable<ArchiveJobIdTitle[]> {
		return this.http.get<ArchiveJobIdTitle[]>(`${this.appConfigService.getConfig().webApi}/api2/archiveJobs/PreRun`)
			.pipe(catchError(this.errorHandler.handleError<ArchiveJobIdTitle[]>(`get archive jobs`)));
	}

	public addDocsToArchiveJob(archiveJobId: string, payload: BulkDocAddPayload): Observable<any> {
		return this.http.put(`${this.appConfigService.getConfig().webApi}/api2/archiveJobs/${archiveJobId}/bulk`, payload)
			.pipe(catchError(this.errorHandler.handleError<any>(`get archive jobs`)));
	}
}
